<template>
  <component
    :is="url ? UiSmartLink : 'div'"
    :to="url"
    class="label-container"
    :aria-label="text"
  >
    <UiIcon
      v-if="icons?.left?.name"
      :name="icons.left.name"
      class="left-icon"
      size="24px"
      :color-fill="icons.left.colorFill || color"
      :is-clickable="!!url"
    />
    <div class="text-container">
      {{ text }}
      <div v-if="subtext" class="body-s subtext">{{ subtext }}</div>
    </div>
    <UiIcon
      v-if="icons?.right?.name"
      :name="icons.right.name"
      class="right-icon"
      size="24px"
      :color-fill="icons.right.colorFill || color"
      :is-clickable="!!url"
    />
  </component>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import UiIcon from '@sephora-asia/ui-icon/UiIcon.vue'
import UiSmartLink from '@sephora-asia/ui-smart-link/UiSmartLink.vue'

interface Props {
  text: string
  subtext?: string
  url?: string | object
  /**
   *  ----- Icon -----
   */
  icons?: {
    left?: {
      name?: typeof UiIcon.name
      colorFill?: typeof UiIcon.colorFill
    }
    right?: {
      name?: typeof UiIcon.name
      colorFill?: typeof UiIcon.colorFill
    }
  }
  /**
   *  ----- Styles -----
   */
  color?: string
}

const props = defineProps<Props>()

const computedColor = computed(
  (): string => props.color || 'var(--color-base-black)'
)
</script>

<style lang="scss" scoped>
.label-container {
  color: v-bind(computedColor);
  display: flex;
  flex-direction: row;

  --icon-margin: 4px;
  .left-icon {
    margin-right: var(--icon-margin);
  }

  .right-icon {
    margin-left: var(--icon-margin);
  }

  .subtext {
    color: var(--color-base-grey-50);
  }
}

a {
  text-decoration: none;

  &:hover {
    &,
    .subtext {
      color: var(--color-base-red-100);
    }
    &:deep(.icon-container svg) {
      fill: var(--color-base-red-100);
    }
  }
}
</style>
